import { useState } from "react";
import "./leadCapture.css";
import { submitMedicareLead } from "./lib/api.js";

export default function MedicareAdvantageForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    setError("");

    const form = new FormData(e.currentTarget);

    const payload = {
      firstName: form.get("FirstName"),
      lastName: form.get("LastName"),
      phone: form.get("Phone"),
      email: form.get("Email"),
      zip: form.get("Zip"),
      county: form.get("County"),
      state: form.get("State"),
      medicareStatus: form.get("MedicareStatus"),
      partA: form.get("MedicarePartAStartDate"),
      partB: form.get("MedicarePartBStartDate"),
      interestedIn: form.get("InterestedIn"),
      notes: form.get("Notes"),
      consent: form.get("TCPAConsent") === "Yes",
      leadSource: form.get("LeadSource"),
      campaign: form.get("Campaign"),
    };

    try {
      const data = await submitMedicareLead(payload);

      if (!data?.ok) {
        throw new Error(data?.error || "Lead submission failed");
      }

      setSubmitted(true);
    } catch (err) {
      console.error("Medicare lead submission error:", err);

      setError("We couldn't submit your information. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="ma-intake-section">
      <div className="ma-intake-content">
        {submitted ? (
          <div className="ma-success-card">
            <h3>Thank you!</h3>
            <p>
              Your information has been submitted. A licensed agent will follow
              up soon.
            </p>
          </div>
        ) : (
          <form className="ma-form" onSubmit={handleSubmit}>
            <div className="ma-field-row">
              <div className="ma-field">
                <label htmlFor="firstName">First name</label>
                <input id="firstName" name="FirstName" type="text" required />
              </div>

              <div className="ma-field">
                <label htmlFor="lastName">Last name</label>
                <input id="lastName" name="LastName" type="text" required />
              </div>
            </div>

            <div className="ma-field-row">
              <div className="ma-field">
                <label htmlFor="phone">Phone number</label>
                <input id="phone" name="Phone" type="tel" required />
              </div>

              <div className="ma-field">
                <label htmlFor="email">Email address</label>
                <input id="email" name="Email" type="email" />
              </div>
            </div>

            <div className="ma-field-row ma-field-row-three">
              <div className="ma-field">
                <label htmlFor="zip">ZIP code</label>
                <input id="zip" name="Zip" type="text" required />
              </div>

              <div className="ma-field">
                <label htmlFor="county">County</label>
                <input id="county" name="County" type="text" />
              </div>

              <div className="ma-field">
                <label htmlFor="state">State</label>
                <input id="state" name="State" type="text" />
              </div>
            </div>

            <div className="ma-field">
              <label htmlFor="medicareStatus">
                Do you currently have Medicare?
              </label>

              <select id="medicareStatus" name="MedicareStatus" required>
                <option value="">Select an option</option>

                <option value="Yes - Original Medicare">
                  Yes - Original Medicare
                </option>

                <option value="Yes - Medicare Advantage">
                  Yes - Medicare Advantage
                </option>

                <option value="Yes - Medicare Supplement">
                  Yes - Medicare Supplement
                </option>

                <option value="No">No</option>
              </select>
            </div>

            <div className="ma-field-row">
              <div className="ma-field">
                <label htmlFor="partA">Part A start date</label>
                <input
                  id="partA"
                  name="MedicarePartAStartDate"
                  type="text"
                  placeholder="MM/DD/YYYY"
                />
              </div>

              <div className="ma-field">
                <label htmlFor="partB">Part B start date</label>
                <input
                  id="partB"
                  name="MedicarePartBStartDate"
                  type="text"
                  placeholder="MM/DD/YYYY"
                />
              </div>
            </div>

            <div className="ma-field">
              <label htmlFor="interestedIn">What are you interested in?</label>

              <select id="interestedIn" name="InterestedIn" required>
                <option value="">Select an option</option>

                <option value="Medicare Advantage">Medicare Advantage</option>

                <option value="Prescription Drug Plan">
                  Prescription Drug Plan
                </option>

                <option value="Dental / Vision / Hearing">
                  Dental / Vision / Hearing
                </option>

                <option value="Plan Review">Plan Review</option>
              </select>
            </div>

            <div className="ma-field">
              <label htmlFor="notes">Additional details</label>

              <textarea
                id="notes"
                name="Notes"
                placeholder="Doctors, prescriptions, preferred pharmacy, or questions"
              />
            </div>

            <label className="ma-consent">
              <input name="TCPAConsent" type="checkbox" value="Yes" required />

              <span>
                I agree to be contacted by phone, text, or email about Medicare
                plan options, including by licensed agents. Consent is not
                required to purchase.
              </span>
            </label>

            <input
              type="hidden"
              name="LeadSource"
              value="Website Intake Form"
            />

            <input type="hidden" name="Campaign" value="Medicare Advantage" />

            {error && <p className="ma-form-error">{error}</p>}

            <button className="ma-submit" type="submit" disabled={submitting}>
              {submitting ? "Submitting..." : "Request My Consultation"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
